import { clampRange } from "./numbers.js";
export function getPaginationInfo({ totalItems, perPage, requestedPage, }) {
    const totalPages = Math.max(1, Math.ceil(totalItems / perPage));
    const page = clampRange(requestedPage, { min: 1, max: totalPages });
    const sliceStart = (page - 1) * perPage;
    const sliceEnd = page * perPage;
    return { totalPages, page, sliceStart, sliceEnd, totalItems, perPage };
}
